import {getIPAddress} from "./locationHelpers";

export function sendSlackMessageTracked(message) {
    // Sends a slack message with the client's IP address

    // TODO: Remove this return
    // return


    getIPAddress((ipAddress) => {
        const formattedMessage = `${message} \nIP address: ${ipAddress}`
        console.log("This is hte formatted IP address")
        sendSlackMessage(formattedMessage);
    })
}

export function sendSlackMessage(message, channel = "#website-updates") {
    /*
    Supports: #user-engagement, #website-updates
     */
    let myHeaders = new Headers();
    myHeaders.append("accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify({
        "message": message,
        "channel": channel
    });
    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow',
        body: raw,
    };
    fetch("https://server.pabloo.com/virtual_bank/send_slack_message", requestOptions)
        .then(response => response.text())
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
}



export function handleSubmission(jsonData, callbackFunction) {
    // Takes a dictionary object, and sends the submission to the backend
    // Sends Slack message and saves data to Firebase if applicable

    fetch("https://server.pabloo.com/website/handle_submission", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(jsonData),
    }).then((result) => {
        callbackFunction(result)
    })
        .catch((error) => {
            console.log("An error occured", error);
        });
}
